import React from "react";
import us from ".././assets/us-min.jpg"
import "./Home.css"

export default function UsImg() {
    return (
        <div id="us-img-cont">
            <img id="us-img" src={us} alt="Us"/>
        </div>
    )
}